const pushElement = (element, node, ...rest) => {
    element.content.push(node, ...rest);
};
const popElement = (element) => element.content.pop();
export const createElement = (type, content, attrs) => {
    const element = {
        type,
        content,
        attrs,
        push: (...args) => pushElement(element, ...args),
        pop: () => popElement(element),
    };
    return element;
};
//# sourceMappingURL=stack-element.js.map